import {GetDebtSettlementStatementUrl} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetDebtSettlementStatementUrl} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetDebtSettlementStatementUrl = (): GetDebtSettlementStatementUrl =>
	new RemoteGetDebtSettlementStatementUrl(
		makeBFFApiUrl(ExternalLinkPoint.debtSettlementStatement),
		makeAuthorizeHttpClientDecorator(),
	);
